let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1U1DX")).then(() => parcelRequire('kIqMQ'));